import { Navigate, Outlet } from 'react-router';

import { useSession } from '@/features/auth/useSession';
import { featuresOf, seesPayroll } from '@/shared/session/currentUser';
import { EmptyState } from '@/shared/ui/EmptyState';
import { Spinner } from '@/shared/ui/Spinner';

/**
 * Guard for «Nóminas» (contract v10.53, ADR 0047 of the back). Off in this deployment
 * (`features.payroll`): the screen does not exist, to the inbox like an unknown route. On,
 * without the person's own permission (`can_send_payroll`): a refusal that says who to
 * ask, as Presupuestos does for a profile. «Administra» does not open it and a
 * superadministrator cannot have it.
 *
 * **A convenience, not the control**: the API answers 403 (`X-Cubas-Reason: payroll`) to
 * all of `/api/payroll` whatever this does.
 */
export function RequirePayroll() {
  const session = useSession();

  if (session.isPending) {
    return <Spinner variant="fill" label="Comprobando permisos" />;
  }

  if (!featuresOf(session.data).payroll) {
    return <Navigate to="/correos" replace />;
  }

  if (!seesPayroll(session.data)) {
    return (
      <EmptyState
        title="Las nóminas solo las ve quien las envía"
        hint="Si las necesitas, pídele el permiso a quien mantiene la aplicación."
      />
    );
  }

  return <Outlet />;
}
